// 各航司配置，通过主应用globalState.airline来确定
const apps = [
  {
    domain: 'www.luckyair.net',
    name: '祥鹏航空',
    sortName: '祥鹏',
    airline: '8L',
    logo: 'icon-xiangpenghangkong-012',
    hotline: '95326',
    ticketCode: '859'
  },
  {
    domain: 'www.fuzhou-air.cn',
    name: '福州航空',
    sortName: '福航',
    airline: 'FU',
    logo: 'icon-fuzhouhangkong',
    hotline: '95071666',
    ticketCode: '666'
  },
  {
    domain: 'www.yzr.com.cn',
    name: '金鹏航空',
    sortName: '金鹏',
    airline: 'Y8',
    logo: '',
    hotline: '95071888',
    ticketCode: '871'
  },
  {
    domain: 'www.urumqi-air.com',
    name: '乌鲁木齐航空',
    sortName: '乌航',
    airline: 'UQ',
    logo: '',
    hotline: '95334',
    ticketCode: '886'
  },
  {
    domain: 'www.jdair.net',
    name: '首都航空',
    sortName: '首航',
    airline: 'JD',
    logo: '',
    hotline: '95375',
    ticketCode: '898'
  },
  {
    domain: 'www.airchangan.com',
    name: '长安航空',
    sortName: '长安航',
    airline: '9H',
    logo: '',
    hotline: '95071199',
    ticketCode: '856'
  }
]

export default function () {
  if (window.__MICRO_ROOT__) {
    const app = apps.find(item => item.airline === window.__MICRO_ROOT__?.airline?.toLocaleUpperCase())

    return app || apps[0]
  }

  return apps[0]
}

export const airlines = ['Y8', 'FU', 'UQ', '8L', 'JD', '9H', 'GS', 'PN', 'GX', 'HU']
